import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InicioComponent } from './inicio.component';
import { NgZorroAntdModule} from '../../ng-zorro-antd/ng-zorro-antd.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { ChartHistoricoPesquisasMensalComponent } from './chart-historico-pesquisas-mensal/chart-historico-pesquisas-mensal.component';
import { ChartHistoricoTotalLeadsComponent } from './chart-historico-total-leads/chart-historico-total-leads.component';
import { ChartHistoricoNovosLeadsComponent } from './chart-historico-novos-leads/chart-historico-novos-leads.component';
import { BaseChartDirective } from 'ng2-charts';

@NgModule({
  declarations: [InicioComponent, ChartHistoricoPesquisasMensalComponent, ChartHistoricoTotalLeadsComponent, ChartHistoricoNovosLeadsComponent],
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule,
    FormsModule, 
    ReactiveFormsModule,
    NgZorroAntdModule,
    BaseChartDirective
  ],
  exports: [
    ChartHistoricoPesquisasMensalComponent,
    ChartHistoricoTotalLeadsComponent,
    ChartHistoricoNovosLeadsComponent
  ]
})
export class InicioModule { }
